import { FormInputProps } from '../../../models'

export const FormInput = <TFormValues extends Record<string, unknown>>({
  onChange,
  nombre,
  nombreCampo,
  reglas,
  register,
  placeholder,
  errors,
  isObligatorio,
  className,
  tipo = 'text',
  maxLength,
  disabled,
  min,
  defaultValue,
}: FormInputProps<TFormValues>) => {
  const inputProps = register ? register(nombreCampo, reglas) : undefined

  return (
    <>
      <div className={className}>
        {nombre && (
          <label className='form-label fs-4'>
            {nombre} {isObligatorio && <span className='text-danger'>*</span>}
          </label>
        )}
        <input
          {...(inputProps ?? {})}
          autoComplete='off'
          type={tipo}
          maxLength={maxLength}
          required={isObligatorio}
          className='form-control form-control-solid'
          placeholder={placeholder}
          disabled={disabled}
          onChange={(e) => {
            inputProps?.onChange?.(e)
            onChange?.(e)
          }}
          min={min}
          defaultValue={defaultValue}
        />
        {errors && errors[nombreCampo] && (
          <p className='text-danger text-end fs-5'>{errors[nombreCampo]?.message}</p>
        )}
      </div>
    </>
  )
}
